import { Card, LoginForm } from "../components";
import { usePageTitle } from "../hooks";

/**
 * LoginPage - Parent login page with Supabase Auth integration.
 */
export function LoginPage() {
  usePageTitle("Log In");

  return (
    <div className="flex flex-col items-center justify-center flex-1 px-4 py-8">
      <Card variant="elevated" className="w-full max-w-md p-8">
        <h1 className="font-display font-bold text-display-sm text-magic-600 text-center mb-2">
          Welcome Back!
        </h1>
        <p className="font-body text-body-md text-neutral-600 text-center mb-8">
          Log in to continue your child's learning adventure
        </p>

        <LoginForm />
      </Card>
    </div>
  );
}

export default LoginPage;
